export default __webpack_public_path__ + "static/media/animation021-05.4ca526c2.svg";